import React from 'react';
import styled from '@emotion/styled';

const TimelineEntry = styled.li`
  margin-right: 30px;
  margin-top: ${props => props.theme.size.small};
  position: relative;
  font-weight: 400;
  letter-spacing: -1px;
  display: flex;
  flex-direction: row;
  width: 80px;

  &:last-child::after {
    background-color: transparent;
  }

  &::after {
    content: '';
    background-color: ${props => props.theme.colors.darkTransparent};
    position: absolute;
    right: -15px;
    top: 2px;
    height: 18px;
    width: 1px;
  }
`;

const TimeLineEntryEmoji = styled.span`
  padding-left: 8px;
`;

export default function TimelineDate(props) {
  return (
    <TimelineEntry>
      {props.entry.date}
      <TimeLineEntryEmoji>{props.entry.status}</TimeLineEntryEmoji>
    </TimelineEntry>
  );
}
